import { mapActions, mapState } from 'vuex' 

import LinkPush from '@/components/LinkPush'

export default {
  data() {
    return {

    }
  },
  components: { 
    LinkPush
  },
  computed: {
    ...mapState([
      'user'
    ])
  },
  watch: {
    data()
    {
      if(!this.data) return
      this.$nextTick( () => {
        document.body.style.cursor = 'inherit'
        this.$refs.wrapper.addEventListener('scroll', this.onWheel)
      })
    }
  },
  methods: 
  {
    onWheel()
    {
      if(!this.$tools.isMobile()) return

      // console.log('scroll', this.$refs.wrapper.scrollTop)

      if(this.$refs.wrapper.scrollTop > 0){
        this.$refs.wrapper.style.top = "0px"
        this.$el.querySelector('.Panel_close').style.top = "0px"
      }
      else
      {
        this.$refs.wrapper.style.top = null
        this.$el.querySelector('.Panel_close').style.top = "150px"
      }
    },
    closePanel()
    {
      this.data = null
      setTimeout( () => { this.$emit('closePanel') }, 500)
    },
    ga()
    {
      // this.$ga.page({
      //   page: window.location.pathname,
      //   title: document.title,
      //   location: window.location.href
      // })
    }
  },
  created()
  {
    this.$tools.disableScroll()
    document.body.style.cursor = "wait"
  },
  beforeDestroy() {
    this.$tools.enableScroll()

    if(this.$refs.wrapper)
      this.$refs.wrapper.removeEventListener('scroll', this.onWheel)
  },
  mounted () {
    this.ga()
    if(this.$refs.wrapper)
      this.onWheel()
  }
}
